import Caret from 'icons/Caret';
import React from 'react';
import styled from 'styled-components';
import { variables } from 'styleUtils';

import {
	defaultInputStyles,
	FormGroup,
	inputTransition,
	Label
} from './styles';

const StyledSelect = styled.select`
  ${() => defaultInputStyles()}
  ${() => inputTransition()}
  width: 100%;
  background: none;
  :focus {
    outline: none;
    box-shadow: none;
  }
`;

const SelectContainer = styled.div`
  position: relative;
  width: 100%;
  ${props => props.cancel && 'width: 35px;'}
  margin-bottom: 10px;

  select {
    margin-bottom: 0;
  }

  svg {
    position: absolute;
    right: 0;
    transform: rotate(180deg);
  }
`;

const Select = ({
	children, label, value, defaultValue, name, onChange, className, cancel, containerClass,
}) => (
	<FormGroup className={containerClass}>
		<SelectContainer cancel={cancel}>
			<Caret
				fill={variables.darkGrey}
				stroke={variables.darkGrey}
				width="10px"
				height="100%"
			/>
			<StyledSelect className={`${className} ${value && 'filled'}`} name={name} defaultValue={defaultValue} value={value} onChange={onChange}>
				{children}
			</StyledSelect>
			<Label htmlFor={name}>{label}</Label>
		</SelectContainer>
	</FormGroup>
);

export default Select;
